import { controller, target, targets } from "@github/catalyst"

// Row checkboxes with a header "select all" box and a submit button that is
// only enabled while something is selected. The count text is rendered by
// the server as data-count-template ("%{count} selected") and filled in here.
@controller
class BulkSelectElement extends HTMLElement {
  @target all!: HTMLInputElement
  @target submit!: HTMLButtonElement
  @target count!: HTMLElement
  @targets boxes!: HTMLInputElement[]

  connectedCallback() {
    this.update()
  }

  toggleAll() {
    for (const box of this.boxes) box.checked = this.all.checked
    this.update()
  }

  update() {
    const selected = this.boxes.filter((box) => box.checked).length
    this.all.checked = selected > 0 && selected === this.boxes.length
    this.all.indeterminate = selected > 0 && selected < this.boxes.length
    this.submit.disabled = selected === 0
    const template = this.count.getAttribute("data-count-template") || ""
    this.count.textContent = template.replace("%{count}", String(selected))
    this.count.hidden = selected === 0
  }
}

export default BulkSelectElement
